import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*eslint-disable react/prop-types */
import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';
import { elementType, componentOrElement } from '../../wui-core/src';
import Portal from './Portal';
import ModalManager from './ModalManager';
import ownerDocument from './utils/ownerDocument';
import addEventListener from './utils/addEventListener';
import addFocusListener from './utils/addFocusListener';
import canUseDom from 'dom-helpers/util/inDOM';
import activeElement from 'dom-helpers/activeElement';
import contains from 'dom-helpers/query/contains';
import getContainer from './utils/getContainer';
var modalManager = new ModalManager();
/**
 * 模态框
 */

var propTypes = _objectSpread(_objectSpread({}, Portal.propTypes), {}, {
  /**
   * 是否显示
   */
  show: PropTypes.bool,

  /**
   * 容器
   */
  container: PropTypes.oneOfType([componentOrElement, PropTypes.func]),

  /**
   * 当模态框打开时的钩子函数
   */
  onShow: PropTypes.func,

  /**
   * 当show参数为false时触发的模态框关闭时的钩子函数
   */
  onHide: PropTypes.func,

  /**
   * 是否包含背景
   */
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['static'])]),

  /**
   *返回背景组件的函数
   */
  renderBackdrop: PropTypes.func,

  /**
   * 设置esc键特殊钩子函数
   */
  onEscapeKeyUp: PropTypes.func,

  /**
   * 当点击背景时触发的函数
   */
  onBackdropClick: PropTypes.func,

  /**
   * 背景的style
   */
  backdropStyle: PropTypes.object,

  /**
   * 背景的class
   */
  backdropClassName: PropTypes.string,

  /**
   *容器的class
   */
  containerClassName: PropTypes.string,

  /**
   * 按esc键是否关闭模态框
   */
  keyboard: PropTypes.bool,

  /**
   * 动画组件
   */
  transition: elementType,

  /**
   * 设置动画超时时间
   */
  dialogTransitionTimeout: PropTypes.number,

  /**
   * 设置背景动画超时时间
   */
  backdropTransitionTimeout: PropTypes.number,

  /**
   * 是否自动设置焦点
   */
  autoFocus: PropTypes.bool,

  /**
   * 防止焦点离开模态框
   */
  enforceFocus: PropTypes.bool,

  /**
   * 模态框进入时的钩子函数
   */
  onEnter: PropTypes.func,

  /**
   * 模态框开始进入时的钩子函数
   */
  onEntering: PropTypes.func,

  /**
   * 模态框进入后的钩子函数
   */
  onEntered: PropTypes.func,

  /**
   * 模态框退出时的钩子函数
   */
  onExit: PropTypes.func,

  /**
   * 模态框开始退出时的钩子函数
   */
  onExiting: PropTypes.func,

  /**
   * 模态框推出后的钩子函数
   */
  onExited: PropTypes.func,

  /**
   *管理model状态的实例
   */
  manager: PropTypes.object.isRequired
});

var defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return /*#__PURE__*/React.createElement("div", props);
  }
};

var BaseModal = /*#__PURE__*/function (_Component) {
  _inherits(BaseModal, _Component);

  var _super = _createSuper(BaseModal);

  function BaseModal(props, content) {
    var _this;

    _classCallCheck(this, BaseModal);

    _this = _super.call(this, props);
    _this.state = {
      exited: !_this.props.show
    };
    _this.onShow = _this.onShow.bind(_assertThisInitialized(_this));
    _this.onHide = _this.onHide.bind(_assertThisInitialized(_this));
    _this.setMountNode = _this.setMountNode.bind(_assertThisInitialized(_this));
    _this.handleHidden = _this.handleHidden.bind(_assertThisInitialized(_this));
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_assertThisInitialized(_this));
    _this.handleDocumentKeyUp = _this.handleDocumentKeyUp.bind(_assertThisInitialized(_this));
    _this.checkForFocus = _this.checkForFocus.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.restoreLastFocus = _this.restoreLastFocus.bind(_assertThisInitialized(_this));
    _this.enforceFocus = _this.enforceFocus.bind(_assertThisInitialized(_this));
    _this.getDialogElement = _this.getDialogElement.bind(_assertThisInitialized(_this));
    _this.isTopModal = _this.isTopModal.bind(_assertThisInitialized(_this));
    _this.renderBackdrop = _this.renderBackdrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BaseModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({
          exited: false
        });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({
          exited: true
        });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      if (!this.props.show && nextProps.show) {
        this.checkForFocus();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.show) {
        this.onShow();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var transition = this.props.transition;

      if (prevProps.show && !this.props.show && !transition) {
        // Otherwise handleHidden will call this.
        this.onHide();
      } else if (!prevProps.show && this.props.show) {
        this.onShow();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
          show = _this$props.show,
          transition = _this$props.transition;

      if (show || transition && !this.state.exited) {
        this.onHide();
      }

      this.mounted = false;
    }
  }, {
    key: "onShow",
    value: function onShow() {
      var doc = ownerDocument(this);
      var container = getContainer(this.props.container, doc.body);
      this.props.manager.add(this, container, this.props.containerClassName);
      this._onDocumentKeyupListener = addEventListener(doc, 'keyup', this.handleDocumentKeyUp);
      this._onFocusinListener = addFocusListener(this.enforceFocus);
      this.focus();

      if (this.props.onShow) {
        this.props.onShow();
      }
    }
  }, {
    key: "onHide",
    value: function onHide() {
      this.props.manager.remove(this);

      this._onDocumentKeyupListener.remove();

      this._onFocusinListener.remove();

      this.restoreLastFocus();
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(ref) {
      this.mountNode = ref ? ref.getMountNode() : ref;
    }
  }, {
    key: "handleHidden",
    value: function handleHidden() {
      this.setState({
        exited: true
      });
      this.onHide();

      if (this.props.onExited) {
        var _this$props2;

        (_this$props2 = this.props).onExited.apply(_this$props2, arguments);
      }
    }
  }, {
    key: "handleBackdropClick",
    value: function handleBackdropClick(e) {
      if (e.target !== e.currentTarget) {
        return;
      }

      if (this.props.onBackdropClick) {
        this.props.onBackdropClick(e);
      }

      if (this.props.backdrop === true) {
        this.props.onHide();
      }
    }
  }, {
    key: "handleDocumentKeyUp",
    value: function handleDocumentKeyUp(e) {
      if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
        if (this.props.onEscapeKeyUp) {
          this.props.onEscapeKeyUp(e);
        }

        this.props.onHide();
      }
    }
  }, {
    key: "checkForFocus",
    value: function checkForFocus() {
      if (canUseDom) {
        this.lastFocus = activeElement();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var autoFocus = this.props.autoFocus;
      var modalContent = this.getDialogElement();
      var current = activeElement(ownerDocument(this));
      var focusInModal = current && contains(modalContent, current);

      if (modalContent && autoFocus && !focusInModal) {
        this.lastFocus = current;

        if (!modalContent.hasAttribute('tabIndex')) {
          modalContent.setAttribute('tabIndex', -1);
          warning(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
        }

        modalContent.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
      if (this.lastFocus && this.lastFocus.focus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }
    }
  }, {
    key: "enforceFocus",
    value: function enforceFocus() {
      var enforceFocus = this.props.enforceFocus;

      if (!enforceFocus || !this.mounted || !this.isTopModal()) {
        return;
      }

      var active = activeElement(ownerDocument(this));
      var modal = this.getDialogElement();

      if (modal && modal !== active && !contains(modal, active)) {
        modal.focus();
      }
    } //instead of a ref, which might conflict with one the parent applied.

  }, {
    key: "getDialogElement",
    value: function getDialogElement() {
      var node = this.modal;
      return node && node.lastChild;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "renderBackdrop",
    value: function renderBackdrop() {
      var _this2 = this;

      var _this$props3 = this.props,
          backdropStyle = _this$props3.backdropStyle,
          backdropClassName = _this$props3.backdropClassName,
          renderBackdrop = _this$props3.renderBackdrop,
          Transition = _this$props3.transition,
          backdropTransitionTimeout = _this$props3.backdropTransitionTimeout;

      var backdropRef = function backdropRef(ref) {
        return _this2.backdrop = ref;
      };

      var backdrop = /*#__PURE__*/React.createElement("div", {
        ref: backdropRef,
        style: this.props.backdropStyle,
        className: this.props.backdropClassName,
        onClick: this.handleBackdropClick
      });

      if (Transition) {
        backdrop = /*#__PURE__*/React.createElement(Transition, {
          transitionAppear: true,
          in: this.props.show,
          timeout: backdropTransitionTimeout
        }, renderBackdrop({
          ref: backdropRef,
          style: backdropStyle,
          className: backdropClassName,
          onClick: this.handleBackdropClick
        }));
      }

      return backdrop;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          show = _this$props4.show,
          container = _this$props4.container,
          children = _this$props4.children,
          Transition = _this$props4.transition,
          backdrop = _this$props4.backdrop,
          dialogTransitionTimeout = _this$props4.dialogTransitionTimeout,
          className = _this$props4.className,
          style = _this$props4.style,
          onExit = _this$props4.onExit,
          onExiting = _this$props4.onExiting,
          onEnter = _this$props4.onEnter,
          onEntering = _this$props4.onEntering,
          onEntered = _this$props4.onEntered;
      var dialog = React.Children.only(children);
      var mountModal = show || Transition && !this.state.exited;

      if (!mountModal) {
        return null;
      }

      var _dialog$props = dialog.props,
          role = _dialog$props.role,
          tabIndex = _dialog$props.tabIndex;

      if (role === undefined || tabIndex === undefined) {
        dialog = /*#__PURE__*/cloneElement(dialog, {
          role: role === undefined ? 'document' : role,
          tabIndex: tabIndex == null ? '-1' : tabIndex
        });
      }

      if (Transition) {
        dialog = /*#__PURE__*/React.createElement(Transition, {
          transitionAppear: true,
          unmountOnExit: true,
          in: show,
          timeout: dialogTransitionTimeout,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        }, dialog);
      }

      return /*#__PURE__*/React.createElement(Portal, {
        ref: this.setMountNode,
        container: container
      }, /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this3.modal = el;
        },
        role: role || 'dialog',
        style: style,
        className: className
      }, backdrop && this.renderBackdrop(), dialog));
    }
  }]);

  return BaseModal;
}(Component);

;
BaseModal.Manager = ModalManager;
BaseModal.propTypes = propTypes;
BaseModal.defaultProps = defaultProps;
export default BaseModal;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-overlay/src/Modal.js